import { useField } from 'formik'
import React from 'react'
import { Form as BsForm } from 'react-bootstrap'

function Field({ label, help, children, ...props }) {
  const [field, meta] = useField(props)

  return (
    <BsForm.Group>
      <BsForm.Label>{label}</BsForm.Label>
      <BsForm.Control {...field} {...props}>{children}</BsForm.Control>
      {meta.touched && meta.error && (
        <small className='text-danger'>{meta.error}</small>
      )}
      {help && <BsForm.Text className='text-muted'>{help}</BsForm.Text>}
    </BsForm.Group>
  )
}

export default Field
